import styled from 'styled-components'

const IndividualHeroStyle = styled.div`
	--bannerHeight: 47.3%;

    .videoCont,
	.imageCont {
		--proportion: var(--bannerHeight);
		width: 100%;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXLMin}) and (min-width: ${(props) =>
        props.theme.mediaQuery.DesktopSizeL}) {
		--bannerHeight: 46.9%;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) =>
        props.theme.mediaQuery.DesktopSizeM}) {
		--bannerHeight: 53.1%;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) =>
        props.theme.mediaQuery.DesktopSizeS}) {
		--bannerHeight: 47.5%;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) =>
        props.theme.mediaQuery.DesktopSizeXS}) {
		--bannerHeight: 53.2%;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) =>
        props.theme.mediaQuery.TabletSize}) {
		--bannerHeight: 49.4%;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) =>
        props.theme.mediaQuery.TabletSizeS}) {
		--bannerHeight: 49.5%;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
		--bannerHeight: 95.1%;
	}
`

export default IndividualHeroStyle
